import { createStyles, makeStyles } from '@material-ui/styles';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px'
    },
    buttondiv: {
      display: 'flex',
      flexDirection: 'column',
      gap: '5px'
    },
    selectdiv: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      fontSize: '0.875rem',
      margin: 0,
      fontWeight: 500,
      lineHeight: '17px',
      fontStyle: 'normal'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
